export const iconMap: { [key: string]: { [key: string]: { url: string; width: string; explanation: string } } } = {
  lightfastness: {
    "1": { url: "/images/icons/label/lightfastness-1.svg", width: "20", explanation: "Excellent" },
    "2": { url: "/images/icons/label/lightfastness-2.svg", width: "20", explanation: "Very Good" },
    "3": { url: "/images/icons/label/lightfastness-3.svg", width: "20", explanation: "Fair" },
    "4": { url: "/images/icons/label/lightfastness-4.svg", width: "20", explanation: "Poor" },
    "5": { url: "/images/icons/label/lightfastness-5.svg", width: "20", explanation: "Very Poor" },
    "astm 1": { url: "/images/icons/label/lightfastness-astm-1.svg", width: "50", explanation: "Excellent" },
    "astm 2": { url: "/images/icons/label/lightfastness-astm-2.svg", width: "50", explanation: "Very Good" },
    "astm 3": { url: "/images/icons/label/lightfastness-astm-3.svg", width: "50", explanation: "Fair" },
    "astm 4": { url: "/images/icons/label/lightfastness-astm-4.svg", width: "50", explanation: "Poor" },
    "astm 5": { url: "/images/icons/label/lightfastness-astm-5.svg", width: "50", explanation: "Very Poor" },
    "astm i": { url: "/images/icons/label/lightfastness-astm-1.svg", width: "50", explanation: "Excellent" },
    "astm ii": { url: "/images/icons/label/lightfastness-astm-2.svg", width: "50", explanation: "Very Good" },
    "astm iii": { url: "/images/icons/label/lightfastness-astm-3.svg", width: "50", explanation: "Fair" },
    "astm iv": { url: "/images/icons/label/lightfastness-astm-4.svg", width: "50", explanation: "Poor" },
    "astm v": { url: "/images/icons/label/lightfastness-astm-5.svg", width: "50", explanation: "Very Poor" },
    na: { url: "/images/icons/label/lightfastness-na.svg", width: "20", explanation: "" },
  },

  transparency: {
    opaque: { url: "/images/icons/label/transparency-opaque.svg", width: "20", explanation: "opaque" },
    "semi-opaque": { url: "/images/icons/label/transparency-semi-opaque.svg", width: "20", explanation: "semi-opaque" },
    "semi-transparent": { url: "/images/icons/label/transparency-semi-transparent.svg", width: "20", explanation: "semi-transparent" },
    transparent: { url: "/images/icons/label/transparency-transparent.svg", width: "20", explanation: "transparent" },
  },

  staining: {
    "semi-staining": { url: "/images/icons/label/qor-staining-semi-staining.svg", width: "20", explanation: "semi-staining" },
    staining: { url: "/images/icons/label/qor-staining-staining.svg", width: "20", explanation: "staining" },
  },

  grind: {
    coarse: { url: "/images/icons/label/wb-grind-coarse.svg", width: "20", explanation: "coarse" },
    fine: { url: "/images/icons/label/wb-grind-fine.svg", width: "20", explanation: "fine" },
    medium: { url: "/images/icons/label/wb-grind-medium.svg", width: "20", explanation: "medium" },
    "very fine": { url: "/images/icons/label/wb-grind-very-fine.svg", width: "20", explanation: "very fine" },
  },
};

export const dryTimeMap: { [key: string]: string } = {
  Fast: "Fast (1-2 days)",
  Medium: "Medium (2-7 days)",
  Slow: "Slow (5-14 days)",
  "Very Slow": "Very Slow (10-21+ days)",
  "N/A": "N/A",
};
